import { render, staticRenderFns } from "./ProfileInfoDialog.vue?vue&type=template&id=6bb93694&"
import script from "./ProfileInfoDialog.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports